import { render, staticRenderFns } from "./mood-lifter.vue?vue&type=template&id=efbb2b5a&scoped=true&"
import script from "./mood-lifter.vue?vue&type=script&lang=js&"
export * from "./mood-lifter.vue?vue&type=script&lang=js&"
import style0 from "./mood-lifter.vue?vue&type=style&index=0&id=efbb2b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbb2b5a",
  null
  
)

export default component.exports